export { default } from './component';